// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_6c97079b1b--checkbox--Xpuop","phrase":"_6c97079b1b--phrase--VFAUv","link":"_6c97079b1b--link--y0jQM"};